<template>
  <div
    @click="goTo()"
    class="th-card th-hover-pointer container-card-course-2 flex flex-col md:flex-row mx-1 md:mx-0"
  >
    <div class="image w-full md:w-2/5 h-50 md:h-40">
      <img
        :src="
          content.thumbnailSmall
            ? backendUrl + content.thumbnailSmall
            : content.thumbnail
            ? backendUrl + content.thumbnail
            : '/img/thumbnail/empty.png'
        "
        :alt="content.title"
      />
    </div>
    <div class="w-full md:w-3/5 mt-2 md:mt-0 md:ml-4">
      <div class="mb-4">
        <h4 class="title">{{ content ? content.title : "-" }}</h4>
        <p>{{ content ? content.instructor : "-" }}</p>
        <template v-if="content.reviews">
          <rating
            :rating="content ? content.rating : 0"
            :reviews="
              Array.isArray(content.reviews)
                ? content.reviews.length
                : content.reviews
            "
          />
        </template>
        <va-lozenge class="mt-2" :uppercase="false" type="success"
          v-if="category"
          >{{category.name}}</va-lozenge
        >
      </div>
      <div
        class="flex flex-col md:flex-row justify-start md:justify-between md:items-end"
      >
        <div class="text-left mb-2 md:mb-0">
          <div
            v-if="content.type === 'premium' && content.discountedCourse"
            class="flex items-center justify-start mb-1"
          >
            <div class="line-through text-xs opacity-30">
              {{ thousandPrice(content.price) }}
            </div>
            <va-lozenge class="ml-1" :uppercase="true" type="danger"
              >{{ content.discountedCourse.percentage }}%</va-lozenge
            >
          </div>
          <h4>
            {{
              content
                ? content.type === "free"
                  ? "Gratis"
                  : content.discountedCourse
                  ? thousandPrice(content.discountedCourse.price)
                  : thousandPrice(content.price)
                : "-"
            }}
          </h4>
        </div>
        <va-button @click="goTo()" size="sm" type="primary"
          >Lihat Detail</va-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '../Rating'
import thousandPrice from '@/helpers/thousandPrice'

export default {
  name: 'CardCourse2',
  components: {
    Rating,
  },
  data() {
    return {
      thousandPrice,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  computed: {
    category() { return this.content?.category || this.content?.categoryId },
  },
  props: {
    content: {
      type: Object,
    },
  },
  methods: {
    goTo() {
      let id = 1
      console.log(this.content)
      if (this.content?.key) id = this.content.key
      this.$router.push({ name: 'Detail Course', params: { id } })
      this.$store.commit('SET_STATE', { currentMenu: '' })
    },
  },
}
</script>

<style lang="scss">
.container-card-course-2 {
  // width: 540px;
  max-width: 540px;
  padding: 16px;
  .image {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    // width: 40%;
    // height: 150px;
    // &:before {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   width: 100%;
    //   height: 100%;
    //   top: 0;
    //   left: 0;
    //   background: linear-gradient(
    //     0deg,
    //     rgba(0, 0, 0, 0.51) 0%,
    //     rgba(255, 255, 255, 0) 100%
    //   );
    // }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .content {
    // width: 60%;
    // height: 150px;
    display: flex;
    flex-direction: column;
    .title {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price-detail {
      margin-top: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
